<template>
  <button
    data-miros-cold-start="true"
    data-miros-entry="custom"
    :data-miros-lang="mirosLanguage"
    class="inline-flex size-12 items-center justify-center rounded-full bg-background-gray text-white hover:bg-background-gray-hover md:size-14"
  >
    <Icon class="size-6" name="miros-search" />
    <span class="text-base">{{ t['w.module.miros.button']() }}</span>
  </button>
</template>

<script setup lang="ts">
import { useMiros } from '~/composables/miros'
import * as t from '~/messages'

const {
  public: { languageId },
} = useRuntimeConfig()

useMiros()

const mirosLanguage = computed(() => {
  switch (languageId) {
    case 1:
      return 'et'
    case 2:
      return 'fi'
    case 3:
      return 'ru'
    default:
      return 'et'
  }
})
</script>
